var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7734 13.3359C18.332 13.3359 17.9766 13.6914 17.9766 14.1328V17.9766H2.02344V14.1328C2.02344 13.6914 1.66797 13.3359 1.22656 13.3359C0.785156 13.3359 0.429688 13.6914 0.429688 14.1328V18.7734C0.429688 19.2148 0.785156 19.5703 1.22656 19.5703H18.7734C19.2148 19.5703 19.5703 19.2148 19.5703 18.7734V14.1328C19.5703 13.6914 19.2148 13.3359 18.7734 13.3359Z",
    fill: "#673E9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41409 14.2812C9.86331 14.7344 10.4141 14.4844 10.5821 14.2812L15.1641 9.35156C15.4649 9.02734 15.4453 8.52344 15.1211 8.22266C14.7969 7.92188 14.293 7.94141 13.9961 8.26562L10.7969 11.707V1.34766C10.7969 0.90625 10.4414 0.550781 10 0.550781C9.55862 0.550781 9.20316 0.90625 9.20316 1.34766V11.7109L6.00394 8.26953C5.70315 7.94531 5.19925 7.92969 4.87503 8.22656C4.55081 8.52734 4.53519 9.03125 4.83206 9.35547L9.41409 14.2812Z",
    fill: "#673E9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleExport);
export default __webpack_public_path__ + "static/media/purple-export.7f4ceccea4d573665ebc910c8af30be3.svg";
export { ForwardRef as ReactComponent };